// extracted by mini-css-extract-plugin
export var attachment = "_sf-a";
export var emailContainer = "_sf-4";
export var emailContentPaddedContainer = "_sf-b";
export var emailHeader = "_sf-6";
export var emailIframe = "_sf-3";
export var emailInfoIcon = "_sf-9";
export var emailShortenedSummary = "_sf-e";
export var infoDropdown = "_sf-0";
export var infoRowBoundedContent = "_sf-d";
export var internal = "_sf-5";
export var merchant = "_sf-8";
export var messageInputContainer = "_sf-h";
export var normal = "_sf-7";
export var replyCard = "_sf-f";
export var subtleButton = "_sf-1";
export var subtleButtonIconContainer = "_sf-2";
export var toggleViewRepliesButton = "_sf-c";
export var wrappingText = "_sf-g";